import { Box, Container } from "@mui/material";

interface CustomProps {
  children: any;
}

const CenteredAuthenticatedLayout = (props: CustomProps) => {
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        mt: 6,
        pb: 6,
      }}
    >
      <Container maxWidth={"xl"}>{props.children}</Container>
    </Box>
  );
};

export default CenteredAuthenticatedLayout;
